import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import invariant from '../../utils/invariant.js';
import { iconContainer, TOKENS, button } from './button.css.js';

const A11Y = {
  [TOKENS.as.a]: { tabIndex: 0, role: "button" },
  [TOKENS.as.span]: { tabIndex: 0, role: "button" }
};
function Button({
  as: As = TOKENS.as.button,
  children,
  className,
  icon: IconComponent,
  iconPosition: position = TOKENS.icon.position.left,
  size = TOKENS.size.small,
  variant = TOKENS.variant.primary,
  ...rest
}) {
  const content = IconComponent ? /* @__PURE__ */ jsxs("div", { className: `${iconContainer({ position })}`, children: [
    IconComponent,
    children
  ] }) : children;
  const classes = clsx(button({ as: As, size, variant }), className);
  invariant(
    As === TOKENS.as.button || As === TOKENS.as.a || As === TOKENS.as.span,
    `The 'as' prop must be either '${TOKENS.as.button}', '${TOKENS.as.a}' or '${TOKENS.as.span}', but you passed '${As}'`
  );
  const props = { ...A11Y[As], ...rest };
  return /* @__PURE__ */ jsx(As, { className: classes, ...props, children: content });
}

export { Button, Button as default, TOKENS as tokens };
